var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMechanic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 474.848 474.848",
    style: {
      enableBackground: "new 0 0 474.848 474.848"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#721D09"
    },
    cx: 237.424,
    cy: 219.968,
    rx: 99.504,
    ry: 60.496
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.424,
    y: 370.848,
    style: {
      fill: "#F9BDA0"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#721D09"
    },
    d: "M137.616,132.152c-1.328-2.672,4.872-7.896,4.872-7.896l75.064-15.368l4.536,104.008l-28.04,32.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#721D09"
    },
    d: "M337.232,132.152c1.344-2.672-4.856-7.896-4.856-7.896l-75.064-15.368l-4.536,104.008l28.04,32.56"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 189.424,
    y: 186.848,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 200
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "285.424,280.144 285.424,186.848 190.4,186.848 238.632,321.336 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M312.384,102.12c0,72.24-36.624,137.616-74.944,137.616s-74.96-65.376-74.96-137.616 s36.64-84.288,74.96-84.288S312.384,29.872,312.384,102.12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M237.44,17.832c38.32,0,74.944,12.048,74.944,84.288S275.76,239.736,237.44,239.736"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "193.152,286.312 36.96,334.392 44.96,469.2 233.944,421.352  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FCCCB9"
    },
    points: "36.96,334.392 44.96,469.2 233.944,421.352 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "281.712,286.312 437.888,334.392 429.888,469.2 240.888,421.352 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EAA78C"
    },
    points: "437.888,334.392 429.888,469.2 240.888,421.352 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B23A10"
    },
    d: "M247.856,13.072c0,0-4.136,105.92,89.92,117.568c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L247.856,13.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C45022"
    },
    d: "M272.808,3.96c0,0,47.736,60.864-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.552,85.92-27.144,85.92-27.144L272.808,3.96z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.424,
    y: 370.848,
    style: {
      fill: "#EA5807"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.424,
    y: 386.848,
    style: {
      fill: "#B21302"
    },
    width: 384,
    height: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD3A4"
    },
    points: "231.44,474.848 183.232,294.84 36.416,340.424 40.648,474.848 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "231.44,474.848 183.232,286.84 36.416,332.424 56.648,474.848 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "231.44,474.848 183.232,286.84 36.416,332.424 88.648,474.848 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D35E0D"
    },
    points: "243.408,474.848 291.616,286.84 438.432,332.424 434.2,474.848 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEEDEC"
    },
    d: "M227.352,138.36c0,15.68-13.408,28.376-29.92,28.376c-16.528,0-21.936-12.696-21.936-28.376 s5.408-21.288,21.936-21.288C213.944,117.072,227.352,122.68,227.352,138.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M197.432,170.736c-16.728,0-25.936-11.496-25.936-32.376c0-18.2,7.272-25.288,25.936-25.288 c21.56,0,33.92,9.216,33.92,25.288C231.352,156.208,216.136,170.736,197.432,170.736z M197.432,121.072 c-14.08,0-17.936,3.712-17.936,17.288c0,24.376,13.504,24.376,17.936,24.376c14.296,0,25.92-10.936,25.92-24.376 C223.352,126.888,214.632,121.072,197.432,121.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M165.424,138.848h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S167.632,138.848,165.424,138.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEEDEC"
    },
    d: "M247.496,138.36c0,15.68,13.408,28.376,29.92,28.376c16.528,0,21.936-12.696,21.936-28.376 s-5.408-21.288-21.936-21.288C260.904,117.072,247.496,122.68,247.496,138.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M277.416,170.736c-18.704,0-33.92-14.52-33.92-32.376c0-16.072,12.36-25.288,33.92-25.288 c18.664,0,25.936,7.088,25.936,25.288C303.352,159.24,294.144,170.736,277.416,170.736z M277.416,121.072 c-17.2,0-25.92,5.816-25.92,17.288c0,13.44,11.632,24.376,25.92,24.376c4.44,0,17.936,0,17.936-24.376 C295.352,124.784,291.496,121.072,277.416,121.072z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M317.424,138.848h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S319.632,138.848,317.424,138.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M247.512,143.744c-2.208,0-4-1.792-4-4c0-3.352-2.736-6.088-6.096-6.088 c-3.352,0-6.08,2.728-6.08,6.088c0,2.208-1.792,4-4,4s-4-1.792-4-4c0-7.768,6.32-14.088,14.08-14.088 c7.768,0,14.096,6.32,14.096,14.088C251.512,141.952,249.72,143.744,247.512,143.744z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "171.256,281.072 189.888,260.408 237.424,304.408 237.424,394.848 211.584,394.848  194.776,336.96 147.048,298.184 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D35E0D"
    },
    points: "303.592,281.072 284.976,260.408 237.424,304.408 237.424,394.848 263.264,394.848  280.064,336.96 327.8,298.184 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 237.424,
    cy: 315.728,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 237.424,
    cy: 343.408,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 237.424,
    cy: 371.088,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 237.424,
    cy: 398.768,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 237.424,
    cy: 426.4,
    r: 5.336
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "57.544,339.464 53.584,338.824 51.4,341.104 57.744,350.352 63.72,340.848 61.456,338.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "89.248,338.824 85.296,338.176 83.12,340.456 89.464,349.704 95.448,340.192  93.176,338.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "120.96,338.176 117.016,337.52 114.824,339.808 121.2,349.048 127.16,339.544  124.896,337.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "152.68,337.512 148.736,336.872 146.544,339.152 152.92,348.4 158.88,338.896  156.592,336.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "184.392,336.864 180.44,336.224 178.264,338.504 184.608,347.76 190.592,338.256  188.312,336.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "60.928,367.008 56.984,366.376 54.8,368.648 61.152,377.896 67.128,368.4 64.848,366.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "92.64,366.368 88.696,365.728 86.528,368 92.872,377.248 98.824,367.752 96.56,365.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "124.36,365.72 120.4,365.08 118.224,367.352 124.584,376.6 130.544,367.096 128.256,364.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "156.08,365.072 152.12,364.424 149.936,366.704 156.288,375.952 162.264,366.448  160,364.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "187.784,364.424 183.84,363.776 181.656,366.056 188.008,375.304 193.984,365.8  191.712,363.616  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "64.312,394.568 60.368,393.928 58.176,396.2 64.544,405.448 70.512,395.952 68.248,393.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "96.024,393.912 92.08,393.272 89.912,395.552 96.256,404.8 102.24,395.296 99.952,393.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "127.76,393.264 123.816,392.624 121.616,394.904 127.968,404.152 133.944,394.648  131.672,392.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "159.472,392.616 155.52,391.976 153.32,394.256 159.704,403.504 165.656,394  163.384,391.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "191.184,391.968 187.232,391.328 185.056,393.6 191.408,402.848 197.376,393.352  195.112,391.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "67.712,422.112 63.76,421.48 61.584,423.744 67.936,433 73.912,423.504 71.632,421.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "99.424,421.464 95.48,420.832 93.296,423.104 99.64,432.344 105.616,422.848  103.336,420.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "131.144,420.808 127.2,420.176 125.016,422.456 131.376,431.696 137.344,422.2  135.056,420.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "162.88,420.168 158.912,419.52 156.736,421.808 163.088,431.048 169.04,421.544  166.776,419.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "194.584,419.512 190.624,418.872 188.44,421.16 194.8,430.4 200.768,420.896  198.504,418.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "71.112,449.656 67.16,449.024 64.96,451.288 71.328,460.544 77.296,451.048 75.032,448.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "102.808,449.008 98.872,448.376 96.68,450.648 103.04,459.896 109.016,450.4  106.752,448.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "134.544,448.368 130.592,447.728 128.4,450 134.76,459.248 140.736,449.752  138.464,447.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "166.248,447.72 162.304,447.08 160.112,449.352 166.488,458.592 172.448,449.104  170.184,446.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "197.968,447.064 194.008,446.424 191.848,448.704 198.2,457.944 204.176,448.448  201.888,446.264  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "417.312,339.464 421.256,338.824 423.448,341.104 417.096,350.352 411.128,340.848  413.392,338.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "385.6,338.824 389.544,338.176 391.728,340.456 385.376,349.704 379.4,340.192  381.672,338.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "353.888,338.176 357.832,337.52 360.008,339.808 353.656,349.048 347.688,339.544  349.952,337.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "322.152,337.512 326.112,336.872 328.304,339.152 321.928,348.4 315.968,338.896  318.248,336.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "290.456,336.864 294.408,336.224 296.584,338.504 290.24,347.76 284.256,338.256  286.544,336.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "413.92,367.008 417.872,366.376 420.048,368.648 413.696,377.896 407.72,368.4  409.992,366.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "382.216,366.368 386.152,365.728 388.328,368 381.984,377.248 376.008,367.752  378.272,365.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "350.488,365.72 354.44,365.08 356.624,367.352 350.264,376.6 344.288,367.096  346.584,364.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "318.768,365.072 322.72,364.424 324.912,366.704 318.544,375.952 312.584,366.448  314.848,364.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "287.056,364.424 291.008,363.776 293.2,366.056 286.84,375.304 280.872,365.8  283.136,363.616  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "410.544,394.568 414.48,393.928 416.672,396.2 410.304,405.448 404.336,395.952  406.6,393.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "378.808,393.912 382.768,393.272 384.928,395.552 378.584,404.8 372.608,395.296  374.896,393.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "347.088,393.264 351.032,392.624 353.232,394.904 346.88,404.152 340.904,394.648  343.176,392.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "315.376,392.616 319.328,391.976 321.52,394.256 315.144,403.504 309.2,394  311.464,391.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "283.664,391.968 287.608,391.328 289.792,393.6 283.44,402.848 277.464,393.352  279.728,391.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "407.136,422.112 411.08,421.48 413.256,423.744 406.912,433 400.928,423.504  403.216,421.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "375.424,421.464 379.352,420.832 381.552,423.104 375.216,432.344 369.216,422.848  371.496,420.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "343.704,420.808 347.656,420.176 349.832,422.456 343.472,431.696 337.496,422.2  339.784,420.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "311.968,420.168 315.936,419.52 318.112,421.808 311.76,431.048 305.8,421.544  308.064,419.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "280.256,419.512 284.224,418.872 286.408,421.16 280.048,430.4 274.08,420.896  276.344,418.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "403.728,449.656 407.688,449.024 409.888,451.288 403.52,460.544 397.544,451.048  399.808,448.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "372.024,449.008 375.976,448.376 378.152,450.648 371.808,459.896 365.832,450.4  368.096,448.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "340.288,448.368 344.256,447.728 346.44,450 340.088,459.248 334.112,449.752  336.384,447.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "308.592,447.72 312.544,447.08 314.736,449.352 308.36,458.592 302.4,449.104  304.664,446.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "276.88,447.064 280.824,446.424 283,448.704 276.648,457.944 270.664,448.448  272.944,446.264  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#58B3D6"
    },
    points: "374.584,466.848 100.272,466.848 93.496,386.848 381.344,386.848 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4198C4"
    },
    points: "374.584,474.848 100.272,474.848 93.496,402.848 381.344,402.848 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#491D05"
    },
    points: "141.424,466.848 117.424,466.848 117.424,299.688 141.424,292.848 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1C0B03"
    },
    points: "141.424,298.848 141.424,466.848 117.424,466.848 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.288,
    y: 387.568,
    style: {
      fill: "#FFD60B"
    },
    width: 13.832,
    height: 13.824
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF8908"
    },
    points: "135.12,387.536 135.12,401.36 121.288,401.36 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.288,
    y: 423.328,
    style: {
      fill: "#FFD60B"
    },
    width: 13.832,
    height: 13.832
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF8908"
    },
    points: "135.12,423.312 135.12,437.144 121.288,437.144 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#491D05"
    },
    points: "333.424,466.848 357.424,466.848 357.424,299.688 333.424,292.848 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1C0B03"
    },
    points: "333.424,298.848 333.424,466.848 357.424,466.848 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.728,
    y: 387.568,
    style: {
      fill: "#FFD60B"
    },
    width: 13.832,
    height: 13.824
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF8908"
    },
    points: "339.728,387.536 339.728,401.36 353.56,401.36 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.728,
    y: 423.328,
    style: {
      fill: "#FFD60B"
    },
    width: 13.832,
    height: 13.832
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF8908"
    },
    points: "339.728,423.312 339.728,437.144 353.56,437.144 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD9DB"
    },
    d: "M184.416,428.712v-74.328c7.16-3.2,12.144-10.36,12.144-18.696c0-8.304-4.944-15.432-12.032-18.656 l-1.944,19.088h-13.016l-1.92-19.08c-7.104,3.216-12.056,10.352-12.056,18.648c0,8.336,4.984,15.496,12.136,18.688v74.336 c-7.144,3.2-12.136,10.36-12.136,18.696c0,11.304,9.176,20.48,20.488,20.48c11.32,0.008,20.472-9.168,20.472-20.48 C196.56,439.072,191.584,431.912,184.416,428.712z M186.112,451.568l-5.872,5.872l-8.312-0.008l-5.88-5.88l-0.016-8.304l5.896-5.872 l8.312-0.008l5.872,5.872L186.112,451.568L186.112,451.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCCCCE"
    },
    d: "M155.592,335.688c0,8.336,4.984,15.496,12.136,18.688v74.336c-7.144,3.2-12.136,10.36-12.136,18.696 c0,11.304,9.176,20.48,20.488,20.48c11.32,0.008,20.472-9.168,20.472-20.48c0.016-8.336-4.96-15.496-12.128-18.696v-74.328 c7.16-3.2,12.144-10.36,12.144-18.696c0-8.304-4.944-15.432-12.032-18.656l-1.944,19.088h-13.016l-1.92-19.08 M186.112,451.568 l-5.872,5.872l-8.312-0.008l-5.88-5.88l-0.016-8.304l5.896-5.872l8.312-0.008l5.872,5.872L186.112,451.568L186.112,451.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AABEBF"
    },
    d: "M184.416,428.712v-74.328c7.16-3.2,12.144-10.36,12.144-18.696c0-8.304-4.944-15.432-12.032-18.656 l-1.944,19.088h-13.016"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BCCCCE"
    },
    points: "184.08,336.272 176.08,338.504 168.064,336.272 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#CCD9DB"
    },
    points: "184.08,429.96 176.064,432.184 168.064,429.96  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD9DB"
    },
    d: "M209.696,387.104v53.768c-5.16,2.312-8.784,7.496-8.784,13.52c0,6.008,3.576,11.16,8.704,13.496 l1.408-13.808h9.424l1.392,13.8c5.144-2.328,8.704-7.488,8.704-13.488c0-6.032-3.592-11.208-8.768-13.512v-53.776 c5.168-2.312,8.768-7.496,8.768-13.512c0-8.176-6.624-14.816-14.8-14.816c-8.192-0.008-14.816,6.624-14.816,14.816 C200.92,379.608,204.528,384.792,209.696,387.104z M208.48,370.568l4.248-4.248l6.008,0.008l4.256,4.256v6l-4.256,4.248 l-6.008,0.008l-4.248-4.248V370.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCCCCE"
    },
    d: "M230.544,454.392c0-6.032-3.592-11.208-8.768-13.512v-53.776c5.168-2.312,8.768-7.496,8.768-13.512 c0-8.176-6.624-14.816-14.8-14.816c-8.192-0.008-14.816,6.624-14.816,14.816c-0.016,6.024,3.592,11.2,8.768,13.512v53.768 c-5.16,2.312-8.784,7.496-8.784,13.52c0,6.008,3.576,11.16,8.704,13.496l1.408-13.808h9.424l1.392,13.8 M208.48,370.568l4.248-4.248 l6.008,0.008l4.256,4.256v6l-4.256,4.248l-6.008,0.008l-4.248-4.248V370.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AABEBF"
    },
    d: "M209.696,387.104v53.768c-5.16,2.312-8.784,7.496-8.784,13.52c0,6.008,3.576,11.16,8.704,13.496 l1.408-13.808h9.424"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BCCCCE"
    },
    points: "209.944,453.96 215.728,452.352 221.528,453.96 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#CCD9DB"
    },
    points: "209.944,386.2 215.744,384.592 221.528,386.2 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.872,
    y: 406.688,
    style: {
      fill: "#4198C4"
    },
    width: 86,
    height: 63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DCBE8"
    },
    d: "M311.872,405.496c0,1.84-1.504,3.336-3.344,3.336H145.872c-1.84,0-3.328-1.496-3.328-3.336l0,0 c0-1.832,1.488-3.328,3.328-3.328h162.656C310.368,402.168,311.872,403.656,311.872,405.496L311.872,405.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DCBE8"
    },
    d: "M149.872,463.504c-1.84,0-3.328-0.536-3.328-1.208v-59.552c0-0.68,1.488-1.224,3.328-1.224l0,0 c1.84,0,3.328,0.544,3.328,1.224v59.552C153.2,462.96,151.712,463.504,149.872,463.504L149.872,463.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DCBE8"
    },
    d: "M304.528,463.504c-1.84,0-3.328-0.536-3.328-1.208v-59.552c0-0.68,1.488-1.224,3.328-1.224l0,0 c1.84,0,3.328,0.544,3.328,1.224v59.552C307.856,462.96,306.368,463.504,304.528,463.504L304.528,463.504z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanic);
export default __webpack_public_path__ + "static/media/mechanic.869832e76eb9a04387865604b255e0e2.svg";
export { ForwardRef as ReactComponent };